import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class TranslationService extends RestfulService<Models.Translation> {

  constructor(private restService: RestService) {
    super(Models.Translation);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('translations');
  }

}
